<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>people</mat-icon>
      {{ Member.first_name }} {{ Member.last_name }}
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    @for (Membership of Memberships; track Membership) {
      <mat-card class="Membership">
        <mat-card-title>{{ Membership.title }}</mat-card-title>
        <p>
          {{ +Membership.itemCount }} Membership{{ +Membership.itemCount > 1 && 's'
          || ''}}
        </p>
        <p>Valid : {{ Membership.created }} - {{ Membership.expires }}</p>
      </mat-card>
    }
  </section>
  <section align="end" mat-dialog-actions>
    <button mat-button mat-dialog-close matTooltip="Cancel and close.">
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
  </section>
</section>
